export default __webpack_public_path__ + "static/media/Rola_Black_Logo.befd28a0.png";